var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.708 8.70799L14.708 22.708C14.6151 22.8011 14.5048 22.875 14.3833 22.9254C14.2618 22.9758 14.1315 23.0018 14 23.0018C13.8685 23.0018 13.7382 22.9758 13.6167 22.9254C13.4952 22.875 13.3849 22.8011 13.292 22.708L5.29199 14.708L6.70799 13.292L14 20.586L27.294 7.29199L28.708 8.70799Z",
    fill: "#091540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIconDark);
export default __webpack_public_path__ + "static/media/done-icon-dark.77b9f83ac2e660783ffc50e0b8f9a7b6.svg";
export { ForwardRef as ReactComponent };